import gender from './gender/gender';
import stateCapitalAU from './stateCapital/stateCapitalAU';
import medicareAU from './medicare/medicareAU';
import country from './country/country';
import streetType from './streetType/streetType';
import stateAU from './state/stateAU';
import stateMY from './state/stateMY';
import stateHK from './state/stateHK';
import idCardTypePH from './cardType/idCardType';
import cardTypeOCR from './cardType/cardTypeOCR';
import searchType from './searchType/searchType';
import phoneType from './phoneType/phoneType';

// import idCardTypePH from './cardType/idCardTypePH';

const translateDropdown = {
  select: 'Select',
  gender,
  stateCapital: { stateCapitalAU },
  medicare: { medicareAU },
  country,
  streetType,
  stateAU,
  stateHK,
  stateMY,
  idCardTypePH,
  cardTypeOCR,
  searchType,
  phoneType,
};

export default translateDropdown;
